import Modal from "react-bootstrap/Modal";

import EmailModalBody from "./emailModalBody";

const EmailModal = (props) => {
  return (
    <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
      <EmailModalBody hideModal={props.onHide} />
    </Modal>
  );
};

export default EmailModal;
